// Traducciones para formularios - Español
export const formsEs = {
  validation: {
    required: 'Este campo es obligatorio',
    invalidEmail: 'Correo electrónico inválido',
    invalidPhone: 'Número de teléfono inválido',
    minLength: 'Mínimo {min} caracteres',
    maxLength: 'Máximo {max} caracteres',
  },

  fields: {
    name: 'Nombre',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    message: 'Mensaje',
    subject: 'Asunto',
    company: 'Empresa',
    address: 'Dirección',
  },

  actions: {
    submit: 'Enviar',
    reset: 'Restablecer',
    clear: 'Limpiar',
    save: 'Guardar',
    cancel: 'Cancelar',
  },

  messages: {
    success: 'Formulario enviado correctamente',
    error: 'Error al enviar el formulario',
    processing: 'Procesando...',
  },
};



